<template>
  <v-row no-gutters>
    <v-col cols="4">
      <v-autocomplete
        v-model="countryCode"
        @change="handleChange"
        :items="countries"
        :rules="[required]"
        item-text="text"
        item-value="value"
        class="country-code"
        hide-details="auto"
        single-line
        outlined
      >
        <template v-slot:selection="{ item }">
          {{ item.flag }} {{ item.value }}
        </template>
      </v-autocomplete>
    </v-col>
    <v-col cols="8">
      <v-text-field
        v-model="visitorPhone"
        :label="$t('appointment.formCreate.labels.visitorPhone')"
        :rules="rules"
        class="phone-number"
        hide-details="auto"
        maxlength="18"
        outlined
      />
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { required, checkPastedPhoneNumber } from '@/util/errorHandling'
import { phone, maskPhone } from '@/util/masks'
import { dialCodeList } from '@/util/enums'

export default {
  name: 'VisitorPhone',

  props: {
    rules: {
      type: Array,
    },

    country: {
      type: String,
      required: false,
      default: 'BR',
    },
  },

  data() {
    return {
      visitorPhone: null,
      mask: { phone },
      required,
    }
  },

  watch: {
    visitorPhone(value) {
      if (!value) {
        this.setAppointmentFields({ visitor_phone: '' })
        return
      }

      this.handlePhoneNumber()
    }
  },

  computed: {
    ...mapGetters(['appointmentFields', 'appointmentFields']),

    countries() {
      const list = dialCodeList.map((country) => {
        return {
          text: `${country.flag} ${country.dial_code} ${country.name}`,
          value: country.dial_code,
          flag: country.flag,
        }
      })

      return list
    },

    countryCode: {
      get() {
        return this.setInitialCountryCode() ?? ''
      },
      set(value) {
        return value
      },
    },
  },

  methods: {
    ...mapMutations(['setAppointmentFields']),

    handleChange(countryCode) {
      this.setAppointmentFields({ visitor_phone: { country_code: countryCode, phone: this.visitorPhone }})
    },

    handlePhoneNumber() {
      const parsedNumber = checkPastedPhoneNumber(this.visitorPhone)
      this.$nextTick(() => {
        this.visitorPhone = maskPhone(parsedNumber)
        if (this.visitorPhone) this.setAppointmentFields({ visitor_phone: { country_code: this.countryCode, visitor_phone: this.visitorPhone.replace(/[^\d]/g, '') }})
      })
    },

    setInitialCountryCode() {
      if (this.country) return this.findCountryCode(this.country)
      if (!this.defaultValue) return '+55'
      if (typeof this.defaultValue === 'string') return '+55'
      if (typeof this.defaultValue === 'object') return this.defaultValue?.country_code
    },

    findCountryCode(countryAcronym) {
      const country = dialCodeList.find((country) => country.code.includes(countryAcronym))
      return country?.dial_code
    }
  },
}
</script>

<style scoped>
.country-code {
  position: relative;
  left: 1px;
  border-right: none !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.phone-number {
  border-left: none !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
</style>
